import { NgModule } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { GoogleAutocompleteComponent } from './google-autocomplete/google-autocomplete.component';
import { ItemListBrandComponent } from './item-list-brand/item-list-brand.component';
import { DetailOrderComponent } from 'app/pages/order/detail-order/detail-order.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterLink, RouterModule } from '@angular/router';
import { PricePipe } from './pipe/pricepipe/price.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { S3ImageComponent } from './s3-image/s3-image.component';


@NgModule({
  declarations: [ PricePipe, SidebarComponent, FooterComponent, HeaderComponent, GoogleAutocompleteComponent, ItemListBrandComponent, DetailOrderComponent,],
  imports: [S3ImageComponent, NgSelectModule, RouterModule, CommonModule, ReactiveFormsModule, FormsModule, TranslateModule, RouterLink],
  exports: [S3ImageComponent, CommonModule, PricePipe, RouterLink, NgSelectModule, SidebarComponent, FooterComponent, HeaderComponent, GoogleAutocompleteComponent, ItemListBrandComponent, DetailOrderComponent, TranslateModule, RouterLink, FormsModule, ReactiveFormsModule,],
})
export class ShareComponentModule { }
